<template>
	<div class="form-group c-input-checkbox-brand">
		<label v-if="label" class="form__label" :for="slug">{{ label }}</label>
		<div class="c-input-checkbox-brand__inner">
			<div v-for="option in options" :key="option.id" :class="['c-input-checkbox-brand__item', { active: selected.includes(option.id) }]" @click="toggleSlug(option.id)">
				<input type="checkbox" name="input-tags" v-model="selected" :value="option.id" />
				<label>
					<div class="c-input-checkbox-brand__logo">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM17.5694 9.48809C17.839 9.1736 17.8026 8.70012 17.4881 8.43056C17.1736 8.16099 16.7001 8.19741 16.4306 8.51191L10.9576 14.897L7.53033 11.4697C7.23744 11.1768 6.76256 11.1768 6.46967 11.4697C6.17678 11.7626 6.17678 12.2374 6.46967 12.5303L10.4697 16.5303C10.6174 16.6781 10.82 16.7575 11.0288 16.7494C11.2375 16.7414 11.4335 16.6467 11.5694 16.4881L17.5694 9.48809Z"
								fill="currentColor"
							/>
						</svg>
						<img :src="`${assetUrl}/${option.logo}`" />
					</div>
					<span>
						{{ option.name }}
					</span>
				</label>
			</div>
		</div>
		<InputError v-if="hasError" :message="errorMessage"></InputError>
		<InputDescription v-if="description" :message="description"></InputDescription>
	</div>
</template>

<script>
import InputError from './input-error';
import InputDescription from './input-description';
import slugify from '@swipekit/lib/slugify.js';

export default {
	components: {
		InputError,
		InputDescription,
	},

	data: function () {
		return {
			selected: [],
			maxSelection: 1,
		};
	},

	watch: {
		selected: function () {
			if (this.selected.length > this.maxSelection) {
				this.selected.shift();
			}
			this.onChange({
				target: {
					value: this.selected,
				},
			});
		},
		value: function () {
			let valueArr = this.value || [];

			let currentArr = this.selected || [];

			if (valueArr.length !== currentArr.length) {
				this.selected = this.value;
			}
		},
	},

	props: {
		label: {
			type: String,
			default: '',
		},
		validation: {},
		value: {},
		placeholder: {
			type: String,
			default: '',
		},
		noStyle: {
			type: Boolean,
			default: false,
		},
		description: {
			type: String,
			default: '',
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {},
		options: {},
	},

	computed: {
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		slug: function () {
			return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
		},
	},

	methods: {
		toggleSlug: function (id) {
			if (this.selected.includes(id)) {
				let i = this.selected.indexOf(id);
				if (i > -1) {
					this.selected.splice(i, 1);
				}
			} else {
				this.selected.push(id);
			}
		},
		slugify: function (str) {
			return str;
		},
		onChange: function (e) {
			let value = e.target.value;
			let ids = value || [];
			let options = this.options || [];

			let newBrands = [];
			for (let i = 0; i < options.length; i++) {
				let b = options[i];
				for (let j = 0; j < ids.length; j++) {
					if (b.id === ids[j]) {
						newBrands.push(b);
						break;
					}
				}
			}
			this.$emit('input', newBrands);
		},
	},

	created: function () {
		let value = this.value;

		if (value && value.length > 0) {
			// let temp = value.map((board) => {
			//   return board.boardId;
			// });
			this.selected = value; //temp;
		}
	},
};
</script>

<style lang="scss">
.c-input-checkbox-brand {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-bottom: var(--margin-lg);

	&__inner {
		display: flex;
		flex-direction: column;
		width: 100%;

		//border: var(--color-input-background) solid 1px;
		//border-radius: var(--border-radius);
	}

	&__item {
		display: flex;
		align-items: center;
		padding: var(--margin) var(--margin-lg);
		//margin-bottom: var(--margin-lg);
		background-color: transparent;

		cursor: pointer;

		user-select: none;

		input {
			display: none;
		}

		img {
			width: 32px;
			height: 32px;
			border-radius: 32px;
		}

		&:hover {
			background-color: var(--color-button-primary-light);
			color: var(--color-button-font);

			svg {
				opacity: 1;
			}
		}

		label {
			margin: 0;
			display: grid;
			grid-template-columns: 32px 1fr;
			align-items: center;
			font-size: var(--font-size);

			cursor: pointer;

			svg {
				min-width: 24px;
				opacity: 0.5;
				margin-right: var(--margin);
			}

			span {
				display: blocks;
				padding-left: var(--margin);
				width: 100%;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}

		&.active {
			svg {
				color: var(--color-primary);
				opacity: 1;
			}
			background-color: var(--color-primary);
			color: var(--color-button-font);
		}
	}

	&__logo {
		position: relative;
		width: 32px;
		height: 32px;
		margin-right: var(--margin-lg);

		> svg {
			position: absolute;
			top: 4px;
			left: 4px;
			display: none;
		}
	}
}
</style>
